/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-radiation-dosimetry.reducer';

export const TreatmentRadiationDosimetryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRadiationDosimetryEntity = useAppSelector(state => state.treatmentRadiationDosimetry.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRadiationDosimetryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.detail.title">TreatmentRadiationDosimetry</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.id}</dd>
          <dt>
            <span id="administeredDoseDistribution">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseDistribution">
                Administered Dose Distribution
              </Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.administeredDoseDistribution}</dd>
          <dt>
            <span id="administeredDoseCalcAlgorithm">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseCalcAlgorithm">
                Administered Dose Calc Algorithm
              </Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.administeredDoseCalcAlgorithm}</dd>
          <dt>
            <span id="administeredDoseGrid">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseGrid">Administered Dose Grid</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.administeredDoseGrid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.radiationSession ? treatmentRadiationDosimetryEntity.radiationSession.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.dosimetry">Dosimetry</Translate>
          </dt>
          <dd>{treatmentRadiationDosimetryEntity.dosimetry ? treatmentRadiationDosimetryEntity.dosimetry.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-radiation-dosimetry" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-radiation-dosimetry/${treatmentRadiationDosimetryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRadiationDosimetryDetail;
